import { render, staticRenderFns } from "./ModeratorBadgeIcon.vue?vue&type=template&id=3a6b5607&"
import script from "./ModeratorBadgeIcon.vue?vue&type=script&lang=js&"
export * from "./ModeratorBadgeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports